import {connect} from '../../app/connect';
import Sort from './Sort';
import {setQueryParamsAction} from '../../app/actions';
import {getQueryParams} from '../../app/selectors';

const mapStateToProps = state => ({
  queryParams: getQueryParams(state)
});

export default connect(
  mapStateToProps,
  {
    setQueryParamsAction
  }
)(Sort);
